// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// import VueResource from 'vue-resource'
import VeeValidate, { Validator } from 'vee-validate';
import veeHi from './locales/vee_hi';
import veeHinglish from './locales/vee_hinglish';
import i18nPlugin, { loadLocale } from './plugins/i18n'
// import i18nPlugin from './plugins/i18n'
import GlobalTranslator from './plugins/global_translator'

// import VueCroppie from 'vue-croppie';
// import 'croppie/croppie.css' // import the croppie css manually

import 'vue-advanced-cropper/dist/style.css';

import './actioninterface.js';

import {globalMixin} from './global_mixin'

// Disable console log in production
// if (process.env.NODE_ENV === 'production') {
//     console.log = function () {};
// }

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: "#4b77be"
  }
});

Vue.use(i18nPlugin);
Vue.use(GlobalTranslator);

// Preload English (fallback) and the user's saved language before mounting.
// Both plugins share the same locale cache, so a single load serves both.
// var _initialLang = localStorage.getItem('appLanguage') || 'en';
// loadLocale('en');
// if (_initialLang !== 'en') loadLocale(_initialLang);

loadLocale('en');

// Vue.use(VueResource);
Vue.use(require('vue-moment'));
Vue.use(VeeValidate);
Validator.localize('hi', veeHi);
Validator.localize('hinglish', veeHinglish);
// Validator.localize(_initialLang);
// Vue.use(VueCroppie);

Vue.config.productionTip = false;

Vue.prototype.$eventHub = new Vue();
Vue.prototype.WebInterface = {};
Vue.prototype.business = null;

Vue.prototype.scrollOptions = {"duration":300, "offset":-72, "easing":"linear"};

Vue.prototype.configs = require('./config.js').configs;

const dataTypes = require('./config.js').configs.dataTypes;

let refreshing = false;

if(location.search.indexOf('?cache=true') !== -1){
  if ('caches' in window) {
    caches.keys().then(function(cacheNames) {
      cacheNames.forEach(function(cacheName) {
        caches.delete(cacheName);
      });
    });
  }
}

if(window.location.port!=8080 && 'serviceWorker' in navigator){

  console.log('step1');

  window.addEventListener('load', function() {

    console.log('step2');

    navigator.serviceWorker.register('../../service-worker.js')
      .then(function() {
        console.log("ready");
        return navigator.serviceWorker.ready;
      })
      .then(function(response) {

        var checkState = setInterval(function(){
          if(response.active.state=='activated'){
            console.log("activated");
            clearInterval(checkState);
          }
        },50);
      });


    });

  if (navigator.serviceWorker.controller) {
    console.log('This page is currently controlled by:', navigator.serviceWorker.controller);
  }

  navigator.serviceWorker.oncontrollerchange = function() {
    console.log('This page is now controlled by:', navigator.serviceWorker.controller);
    console.log('Install complete. Triggering update prompt.');
    fn_onUpdateFound();
  };
}
else{
  console.log('serviceWorker not found in navigator, loading data online');
}

function fn_onUpdateFound(){
  if(!refreshing){
    console.log("restart app here");
    refreshing = true;
  }
  // var r = confirm("A new update is ready. Do you want to update now?");
  // if(r==true){
  //   window.location.reload();
  // }
  // else{
  //   console.log("refresh cancel");
  // }
}

// Vue.prototype.webVersion = "8";

if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
  // Vue.prototype.business = JSON.parse(AndroidRoutingTest.getBusiness());
  Vue.prototype.deviceInfo = JSON.parse(AndroidRoutingTest.getDeviceInfo());
  // console.log(Vue.prototype.business);
}
else{
  console.log('device api not defined');
}


Vue.prototype.guid = function(){
  if(typeof AndroidRoutingTest!=='undefined' && AndroidRoutingTest!==null)
    return AndroidRoutingTest.guid();
  else
    Vue.prototype.guidWeb();
}

Vue.prototype.guidWeb = function(){
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}


Vue.prototype.roundUpto2Decimals = function (value) {
  // return Number(value.toFixed(2));
  if(value)
    return Math.round(value*100)/100;
  else
    return 0;
}

Vue.prototype.roundUpto5Decimals = function (value) {
  // return Number(value.toFixed(2));
  if(value)
    return Math.round(value*100000)/100000;
  else
    return 0;
}

Vue.prototype.amountNature = function (val) {
  if(val == 1)
    return 'Dr'
  else 
    return 'Cr'
}

Vue.prototype.fn_fixBackgroundScroll = function () {
  let scroll_y = window.scrollY;
  let parentContainer = document.getElementsByClassName('parent-container')[0];
  document.getElementsByTagName("body")[0].classList.add("noscroll");

  parentContainer.classList.add("scrollauto-y");

  parentContainer.scrollTop = scroll_y;
}

Vue.prototype.fn_removeFixBackgroundScroll = function (spy) {
  let parentContainer = document.getElementsByClassName('parent-container')[0];
  document.getElementsByTagName("body")[0].classList.remove("noscroll");
  parentContainer.classList.remove("scrollauto-y");

  let scroll_y = 0;
  spy ? scroll_y = spy : '';

  setTimeout(function() {
    window.scrollTo(0, scroll_y);
  },100);
}


Vue.prototype.fn_getFieldTitle = function(fieldType){
  let type = null
  for(let i=0; i<dataTypes.length; i++){
    if(dataTypes[i].value == fieldType){
      type = dataTypes[i].title;
      break;
    }
  }
  return type;
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App }, 
  template: '<App/>',
  mixins: [globalMixin],
  created: function(){
    var self = this;
    this.fn_getLocalData('appLanguage', function(response){
      if(!response || response === 'null') return;
      let langObj = null
      try { 
        langObj = JSON.parse(response); 
      } catch(e) { /* plain string */ }
      if (!langObj || langObj === 'null' || (langObj && !langObj.language)) return;
      loadLocale(langObj.language).then(function(){
        self.$root.selectedLanguage = langObj.language;
        Validator.localize(langObj.language);
      });
    });
  },
  mounted: function(){
    let self = this;
    window.addEventListener('online', function(event){
      if(navigator.onLine){
        self.$root.fn_startSync();
      }
    });
  }
})


// WEBPACK FOOTER //
// ./src/main.js